import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { AppBarMain } from "components/AppBar";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <>
      <AppBarMain />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <Typography variant="h1" color="inherit">
          404
        </Typography>
        <Button href="/" variant="text" color="inherit">
          {t("label_homepage")}
        </Button>
      </Box>
    </>
  );
}
